export default __webpack_public_path__ + "static/media/ShieldPoweredLOGO.9bb21539.png";